import React, { useContext, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import ReactFilter from '../../components/inputs/ReactFilter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import SegmentContext from '../context/SegmentContext'
import Pagination from '../../layout/Pagination'
import SearchInput from '../../layout/SearchInput'

const CLIENT_QUALIFIER_KEYS = [
  'qualifier_2',
  'qualifier_3',
  'qualifier_4',
  'qualifier_5',
  'qualifier_6',
  'qualifier_7'
]

const getSegmentOptions = (promoQualifiersData, qualifierKey) => {
  const options = promoQualifiersData?.[0]?.[qualifierKey]
  return Array.isArray(options) ? options : []
}

const canShowClientQualifier = (qualifierKey, savedQualifiers, promoQualifiersData) => {
  if (!savedQualifiers?.[qualifierKey]) return false
  if (qualifierKey === 'qualifier_7') {
    return getSegmentOptions(promoQualifiersData, qualifierKey).length > 0
  }
  return true
}

export default function DetailsView(props) {
  const [searchInput, setSearchInput] = useState('')
  const [qualifiers, setQualifiers] = useState(new Map())
  const [qualifiersDic, setQualifiersDic] = useState(new Map())
  const {
    qualifiersData,
    clientsData,
    pagination,
    fetchDataStatus,
    promoQualifiersData,
    setQualifierQuery,
    setSearchQuery,
    qualifierQuery,
    searchQuery,
    handlePaginationClick
  } = useContext(SegmentContext)
  const [resetReactFilters, setResetReactFilters] = useState(false)
  const [allSelectedOptions, setAllSelectedOptions] = useState(new Map())

  useEffect(() => {
    buildQualifiersQuery()
  }, [allSelectedOptions])

  useEffect(() => {
    handleQualifierData()
  }, [qualifiersData, promoQualifiersData])

  const handleSearch = (e) => {
    setSearchInput(e.target.value)
  }

  const handleEnterSearch = (e) => {
    if (e.key === 'Enter') {
      buildSearchQuery()
    }
  }

  const isFilterSelected = () => {
    if (searchQuery && searchQuery.length > 0) return true

    for (const [key, value] of allSelectedOptions) {
      if (value && value.length > 0) return true
    }

    return false
  }
  const buildSearchQuery = () => {
    let queryParam = ''
    if (searchInput) {
      queryParam = `&q=${searchInput}`
    }
    setSearchQuery(queryParam)
  }

  const buildQualifiersQuery = () => {
    let queryParam = '&search_qualifier=true'
    if (allSelectedOptions) {
      for (const [key, value] of allSelectedOptions) {
        if (!value?.length) continue
        const qualifierKey = qualifiersDic.get(key)
        if (!qualifierKey) continue
        queryParam += `&${qualifierKey}=${value.join(',')}`
      }
    }
    setQualifierQuery(queryParam)
  }

  const handleQualifierData = async () => {
    let availableQualifiers = qualifiersData?.available_qualifiers || []
    let savedQualifiers = qualifiersData?.saved_qualifiers?.[0] || {}
    let mapAvailableQualifiers = new Map()
    let mapSavedQualifiers = new Map()
    let mapQualifiersDic = new Map()

    for (const availableQualifier of availableQualifiers) {
      mapAvailableQualifiers.set(availableQualifier.value, availableQualifier.label)
    }

    for (const qualifierKey of CLIENT_QUALIFIER_KEYS) {
      if (!canShowClientQualifier(qualifierKey, savedQualifiers, promoQualifiersData)) {
        continue
      }

      const mappedField = savedQualifiers[qualifierKey]
      const label = mapAvailableQualifiers.get(mappedField)
      if (!label) continue

      mapSavedQualifiers.set(
        label,
        getSegmentOptions(promoQualifiersData, qualifierKey)
      )
      mapQualifiersDic.set(label, qualifierKey)
    }

    setQualifiers(mapSavedQualifiers)
    setQualifiersDic(mapQualifiersDic)
  }

  const resetFilters = () => {
    setSearchInput('')
    setAllSelectedOptions(new Map())
    setSearchQuery('')
    setQualifierQuery('&search_qualifier=true')
    setResetReactFilters(!resetReactFilters)
  }
  return (
    <>
      {qualifiers && qualifiers.size > 0 && (
        <>
          <h4 className="mt-50 text-sub-title">Filtrar clientes por atributos:</h4>
          <div className="filters-container mb-10">
            <FontAwesomeIcon className="filter-icon mr-10" icon={faFilter} />
            {fetchDataStatus?.qualifiers ? (
              <span>Obteniendo filtros...</span>
            ) : (
              Array.from(qualifiers.entries()).map((qualifier, indx) => (
                <div key={`qlf-${indx}`} className="mr-10">
                  <ReactFilter
                    className="mr-10"
                    title={qualifier[0]}
                    identifier={qualifier[0]}
                    options={qualifier[1]}
                    resetWatcher={resetReactFilters}
                    onChange={(e) => {
                      let so = new Map(allSelectedOptions);
                      so.set(e.identifier, e.selectedOptions);
                      setAllSelectedOptions(so);
                    }}
                  />
                </div>
              ))
            )}
          </div>
        </>
      )}
      <div className="search-input-containter mb-10 mt-20">
        <SearchInput
          query={searchInput}
          setSearchInput={setSearchInput}
          onSearch={buildSearchQuery}
          placeholder="Buscar por código o nombre"
          onClearSearch={() => {
            setSearchInput('');
            setSearchQuery('');
          }}
        />
      </div>
      <div className="mb-20">
        {isFilterSelected() && (
          <a onClick={resetFilters} className="reset-filter cursor-pointer mb-20">
            Restablecer filtros aplicados
          </a>
        )}
      </div>
      <div>
        <Table hover responsive>
          <thead className="table-header-gray">
            <tr>
              <th style={{ verticalAlign: 'middle', padding: '10px 25px' }}>
                <span className="th-header-text">CÓDIGO</span>
              </th>
              <th style={{ verticalAlign: 'middle' }}>
                <span className="th-header-text">CLIENTE</span>
              </th>
              {Array.from(qualifiers?.entries() || []).map((qualifier, indx) => (
                <th key={indx} style={{ verticalAlign: 'middle' }}>
                  <span className="th-header-text">{qualifier[0]?.toUpperCase()}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(clientsData || []).length === 0 && searchInput !== '' ? (
              <tr>
                <td colSpan={(qualifiers?.size || 0) + 2} className="td-text-limited td-text-limited-space">
                  No hay resultados
                </td>
              </tr>
            ) : (
              clientsData?.map((client, indx) => {
                const savedQualifiers = qualifiersData?.saved_qualifiers?.[0] || {}

                return (
                  <tr key={indx}>
                    <td className="td-text-limited td-text-limited-space">{client.db_ref}</td>
                    <td className="td-text-limited">{client.name}</td>
                    {CLIENT_QUALIFIER_KEYS.map((qualifierKey) => {
                      if (
                        !canShowClientQualifier(
                          qualifierKey,
                          savedQualifiers,
                          promoQualifiersData
                        )
                      ) {
                        return null
                      }

                      return (
                        <td key={qualifierKey} className="td-text-limited">
                          {client[qualifierKey] || 'N/A'}
                        </td>
                      )
                    })}
                  </tr>
                )
              })
            )}
          </tbody>
        </Table>
        {fetchDataStatus?.clients && <span>Obteniendo datos...</span>}
        {pagination.total_pages > 1 && (
          <nav className="index-table" onClick={handlePaginationClick}>
            <Pagination
              current_page={pagination.current_page}
              total_pages={pagination.total_pages}
            />
          </nav>
        )}
      </div>
    </>
  );
}
